/* eslint-disable @typescript-eslint/no-unused-vars */
import * as X from "@/ui";



import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";

import { TestimonialsSection as TestimonialsSectionClient } from "@/ui/shared/Testimonials";



export function TestimonialsSection(props: X.PageProps<{
  onDownloadApp?: () => void;
}>) {

  const downloadUrl = X.useDownloadUrl(props.locale);
  const testimonial = useTravelerHomePage('testimonial');
  const ratingCard = useTravelerHomePage('testimonialRatingCard');

  return (
    <TestimonialsSectionClient
      id="testimonials"
      // title={data.title}
      // subtitle={data.subtitle}
      testimonials={testimonial.testimonialSlides}
      className="xl:my-20 xl:mb-24"
      locale={props.locale}
      ratingCard={ratingCard}
      cta={props.onDownloadApp ? {
        mobile: (
          <X.Button
            primary lg
            exitHref={downloadUrl}
            // label={tr(data.tes)}
            label={testimonial.cta}
          />
        ),
        desktop: (
          <X.Button
            primary lg
            onClick={props.onDownloadApp}
            // label={tr(data.cta)}
            label={testimonial.cta}
          />
        ),
      } : undefined}
    />
  );
}
